module.exports = __webpack_public_path__ + "img/plus_2.fd71eec3.svg";